<q9-button-toggle-group [(ngModel)]="selectedTab" (change)="onTabChange()">
  <q9-button-toggle [value]="SUB_TABS.DependenciesTab">
    {{ 'CORE.SIDEBAR.DEPENDENCIES_TAB' | translate }}
    <span class="q9-counter">{{ dependenciesTabCount() }}</span>
  </q9-button-toggle>
</q9-button-toggle-group>
<ng-template [cdkPortalOutlet]="tabPortal"></ng-template>
